<template>
  <footer class="app-footer">
    <div class="footer-content">
      <!-- Always show Powered by message -->
      <span>Powered by Taxscan @ {{ currentYear }} All rights reserved.</span>
      <!-- Only show links on Login page -->
      <nav v-if="$route.name === 'Login'" class="footer-nav">
        <a href="https://www.taxscan.in/privacy-policy/" target="_blank" rel="noopener">Privacy Policy</a>
        <span class="divider">|</span>
        <a href="https://www.taxscan.in/terms-and-conditions/" target="_blank" rel="noopener">Terms & Conditions</a>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.app-footer {
  background: var(--color-bg-alt, #f9fafb);
  padding: var(--space-md);
  text-align: center;
  font-family: var(--font-sans, 'Poppins', sans-serif);
  font-size: var(--font-size-sm, 0.875rem);
  color: var(--color-text-muted, #6b7280);
  border-top: 1px solid var(--color-border, #e5e7eb);
}
.footer-content {
  max-width: var(--content-max-width, 1200px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-xs);
}
.footer-nav {
  display: flex;
  gap: var(--space-xs);
  margin-top: var(--space-xs);
}
.divider {
  margin: 0 var(--space-xs);
  color: var(--color-text-muted);
}
.footer-nav a {
  color: var(--color-accent);
  text-decoration: none;
}
.footer-nav a:hover {
  text-decoration: underline;
}
</style>
